import React from 'react';
import { useSelectedAnnotationDetails } from './utils';
export const DrawerTitle = ({
  annotationId
}: {
  annotationId: string;
}) => {
  const selectedAnnotationDetails = useSelectedAnnotationDetails(annotationId);
  if (!selectedAnnotationDetails) {
    return null;
  }
  const title = selectedAnnotationDetails.annotationLabel.title;
  return <>
      {title.charAt(0).toUpperCase() + title.slice(1)} [{selectedAnnotationDetails.id}]
    </>;
};